import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=ebfd854e&scoped=true"
import script from "./Investment.vue?vue&type=script&lang=js"
export * from "./Investment.vue?vue&type=script&lang=js"
import style0 from "./Investment.vue?vue&type=style&index=0&id=ebfd854e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfd854e",
  null
  
)

export default component.exports